import React, { memo } from 'react';
import { List, Skeleton } from 'antd';
import './TaskListSkeleton.less';
import classNames from 'classnames';

interface TaskListSkeletonProps {
  count: number;
  height?: number;
  border?: boolean;
}

export default memo(function TaskListSkeleton(props: TaskListSkeletonProps) {
  const { count } = props;
  if (count <= 0) return null;
  const height = props.height ?? 72;
  const border = props?.border ?? true;
  return (
    <List
      className={classNames({
        'task-list-skeleton': true,
        'task-list-skeleton--no-border': !border
      })}
      dataSource={new Array(count).fill(undefined).map((_, i) => ({ key: i }))}
      renderItem={() => (
        <List.Item>
          <Skeleton.Input style={{ height: height - 13 }} />
        </List.Item>
      )}
    />
  );
});
